export default {
  'Submit': '提交',
  'Save': '保存',
  'enterOTP': '输入验证码',
  'otpSent': '验证码已发送',
  'login/signup': '登录/注册',
  'notRegisteredLogIn': '此号码非签约商家账号，请输入正确账号。有问题请联系您的客户经理',
  'resendCode': '重新发送验证码',
  'edit': '编辑',
  'otpMessage': '已向您手机发送六位数验证码',
  'oyo360WelcomeMessage': '登录/注册',
  'oyo360ResendCode': '重新发送验证码',
  'oyo360Edit': '编辑',
  'oyo360otpMessage': '已向您手机发送六位数验证码',
  'buttonActionContinue': '继续',
  'chooseLanguage': '选择语言',
  'currentLanguage': '已使用语言',
  'otherLanguages': '其他语言',
  'google': '谷歌',
  'facebook': '脸书',
  'or': '或',
  'buttonActionSubmit': '提交',
  'welcomeTitle': 'OYO欢迎你',
  'welcomeHeadingForMailLogin': '请输入注册绑定的邮箱',
  'welcomeHeadingForPhoneLogin': '请输入注册绑定的手机号',
  'welcomeHeadingForLogin': '请输入您的注册邮箱/手机号',
  'userNameLabel': '邮箱地址/手机号',
  'userNameErrorMessage':'请输入正确的邮箱地址/手机号',
  'emailIdLabel': '邮箱地址',
  'phoneNumberLabel': '手机号',
  'passwordLabel': '密码',
  'newPasswordLabel': '新密码',
  'confirmNewPasswordLabel': '确认新密码',
  'emailErrorMessage': '请输入正确邮箱',
  'phoneNumberErrorMessage': '请输入正确手机号',
  'passwordErrorMessage': '请输入正确密码',
  'confirmPasswordErrorMessage': '密码错误',
  'generateNewPassword': '生成新密码',
  'loginButtonLabel': '登陆',
  'loginWithPhoneButtonLabel': '使用手机号码登录',
  'loginWithOtp': '使用验证码登录',
  'loginWithEmailButtonLabel': '使用邮箱登录',
  'back': '返回',
  'loginWithOtpTitle': '输入验证码',
  'loginWithOtpHeading': '验证码将发送至您的注册手机号',
  'listYourProperty': '酒店清单',
  'privacyPolicy': '隐私政策',
  'verifyEmail': '验证邮箱地址',
  'verifyMobile': '验证手机号',
  'forgotPasswordPhoneSubHeading': '我们将发送六位数验证码验证手机号',
  'forgotPasswordMailSubHeading': '我们将发送六位数验证码验证邮箱',
  'newPasswordCondition1': '密码应同时包括数字和符号',
  'newPasswordCondition2': '密码应至少八位数',
  'newPasswordCondition3': '密码应包括大小写',
  'confirmLogin': '确认并登录',
  'getOTP': '获取验证码',
  'invalidInput': '输入无效',
  'passwordResetMessage': '密码成功生成',
  'otpErrorMessage': '请输入正确的验证码',
  'resendOtpSuccessMessage': '已成功向您的手机发送验证码',
  'InternalServerErrorMessage': '内部服务器错误',
  'resetPasswordHeading': '六位数验证码已发送至邮箱和手机',
  'signingIn': '登陆中',
  'invalidMobileNumber': '无效手机号',
  'privacyFooterText': '登录您的帐户即表示您同意我们的{termsOfUse}和{privacyPolicy}',
  'and': '且',
  'termsOfUse': '使用条款',
  'listProperty': '酒店清单',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': '您没有关联的酒店',
  'facingIssue': ' 遇到问题？',
  'oldLoginViewSwitch': '请切换到旧版',
  'passwordChangeInformationText': '更改密码后，您将从所有设备自动退出，届时需要您使用新密码登陆'
};
